import React from "react";
import { Link } from "react-router-dom";
import { Loader2 } from "lucide-react";

// Base button classes with full state set: normal, hover, focus, active, disabled, loading.
const base =
  "inline-flex items-center justify-center gap-2 min-h-[48px] px-6 rounded-md font-semibold text-[15px] " +
  "transition-colors duration-200 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-offset-2 " +
  "focus-visible:ring-teal disabled:opacity-50 disabled:pointer-events-none active:translate-y-px";

const variants = {
  primary: "bg-teal text-white hover:bg-[#075652] focus-visible:ring-teal",
  secondary: "bg-navy text-white hover:bg-[#123B5A] focus-visible:ring-navy",
  outline: "border border-[#D9E0E4] bg-white text-navy hover:bg-[#EAF1F4]",
  ghostLight: "border border-white/30 text-white hover:bg-white/10",
};

export const CTAButton = ({
  as = "button",
  to,
  href,
  variant = "primary",
  loading = false,
  disabled = false,
  className = "",
  children,
  icon: Icon,
  ...rest
}) => {
  const cls = `${base} ${variants[variant]} ${className}`;
  const content = (
    <>
      {loading ? <Loader2 className="h-4 w-4 animate-spin" aria-hidden="true" /> : Icon ? <Icon className="h-4 w-4" aria-hidden="true" /> : null}
      {children}
    </>
  );

  if (to) {
    return (
      <Link to={to} className={cls} aria-disabled={disabled} {...rest}>
        {content}
      </Link>
    );
  }
  if (href) {
    return (
      <a href={href} className={cls} {...rest}>
        {content}
      </a>
    );
  }
  const Tag = as;
  return (
    <Tag className={cls} disabled={disabled || loading} {...rest}>
      {content}
    </Tag>
  );
};

export default CTAButton;
